import React, {useCallback, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    FaArrowLeft,
    FaArrowUp,
    FaUniversity,
    FaArrowDown,
} from "react-icons/fa";
import {FaBitcoin} from "react-icons/fa6";
import {useSelector} from "react-redux";
import {selectUser} from "../../../../redux/slices/userSlice";
import ProfileFunction from "../../../../functions/profileFunction/ProfileFunction";
import WithDraw from "../../../../services/withDraw";
import fixDate from "../../../../components/DateFormatter/FixDate";
import withDraw from "../../../../services/withDraw";

// تابع فرمت کردن اعداد فارسی با کاما
const formatPrice = (num) => {
    if (!num || num === 0) return "0";
    return num.toLocaleString("en-EN");
};

export default function Commission() {
    ProfileFunction();
    const userData = useSelector(selectUser);
    const navigate = useNavigate();
    const [selectedGateway, setSelectedGateway] = useState("bank");
    const [withdrawAmount, setWithdrawAmount] = useState(0);
    const [BALANCE, setBALANCE] = useState(0);

    useEffect(() => {
        setBALANCE(userData?.wallet?.balance);
    }, [userData])
    const MINIMUM_AMOUNT = 10000;
    const FIXED_FEE = 2500;
    const QUICK_AMOUNTS = [50000, 100000, 250000, 500000];

    // Handle gateway selection
    const handleGatewayChange = (gateway) => {
        setSelectedGateway(gateway);
    };

    // Handle amount input
    const handleAmountChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setWithdrawAmount(value);
    };

    // Handle quick amount buttons
    const handleQuickAmount = (amount) => {
        setWithdrawAmount(amount);
    };

    // Handle max button
    const handleMaxAmount = () => {
        setWithdrawAmount(BALANCE);
    };

    // Calculate final amount
    const finalAmount = Math.max(0, withdrawAmount - FIXED_FEE);

    const [withDraws, setWithDraws] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const LIMIT = 10;
    const fetchWithDraws = async (pageNumber = 1) => {
        if (loading || !hasMore) return;

        setLoading(true);

        try {
            const res = await WithDraw.getMyWithDraws({
                page: pageNumber,
                limit: LIMIT,
            });

            const data = res?.data?.data;

            setWithDraws(prev =>
                pageNumber === 1
                    ? data.docs
                    : [...prev, ...data.docs]
            );

            // یکی از این دو حالت بسته به API
            setHasMore(data.hasNextPage);
            // یا
            // setHasMore(pageNumber < data.totalPages);

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWithDraws(1);
    }, []);

    const observer = useRef();

    const lastWithdrawRef = useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                const nextPage = page + 1;
                setPage(nextPage);
                fetchWithDraws(nextPage);
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore, page]);

    const [btnLoading, setBtnLoading] = useState(false);

    async function SettleWithDraw() {
        setBtnLoading(true);
        try {
            await withDraw.settleWithDraw({amount: withdrawAmount});
            fetchWithDraws();
            setBALANCE(BALANCE - withdrawAmount);
            setWithdrawAmount(0);
        } catch (error) {
            console.error('Error settle with draw', error);
        } finally {
            setBtnLoading(false);
        }
    }


    return (
        <div dir="ltr" className="px-5">
            <header className="fixed top-0 left-0 p-4 right-0 shadow-sm z-50 bg-white border-b border-gray-100">
                <div className="flex items-center justify-between">
                    <button
                        onClick={() => navigate("/profile")}
                        className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
                    >
                        <FaArrowLeft className="text-gray-600"/>
                    </button>
                    <h1 className="text-xl font-bold text-gray-900">Withdraw Commission</h1>
                    <div className="w-10"></div>
                </div>
            </header>
            <div className="bg-gradient-to-br mt-20 from-blue-600 to-indigo-500 rounded-3xl p-6 shadow-lg">
                <div className="text-center">
                    <div className="text-white/90 text-sm mb-2">Available Withdrawable Balance</div>
                    <div className="text-4xl font-bold text-white mb-2">
                        {formatPrice(BALANCE)} USDT
                    </div>
                    <div className="flex items-center justify-center text-white/90 text-sm text-left gap-2">
                        <FaArrowUp size={16} className="text-xs ml-1 mb-3"/>
                        <span>15% growth in available Withdrawable balance this month</span>
                    </div>
                </div>
            </div>
            <div className="mt-4 relative z-10">
                <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 mb-6">
                    <h2 className="text-xl font-bold text-gray-900 mb-6">
                        Withdraw Commission
                    </h2>

                    {/* Gateway Selection */}
                    <div className="mb-6">
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                            Payment Gateway
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                            <label className="relative cursor-pointer">
                                <input
                                    type="radio"
                                    name="gateway"
                                    value="bank"
                                    checked={selectedGateway === "bank"}
                                    onChange={(e) => handleGatewayChange(e.target.value)}
                                    className="sr-only peer"
                                />
                                <div
                                    className="bg-gray-50 border-2 border-gray-200 rounded-2xl p-4 peer-checked:border-blue-600 peer-checked:bg-blue-50 transition-all">
                                    <div className="flex flex-col items-center text-center">
                                        <FaUniversity
                                            className="text-2xl text-gray-600 peer-checked:text-blue-600 mb-2"/>
                                        <span className="text-sm font-medium text-gray-700">
                      Bank Transfer
                    </span>
                                    </div>
                                </div>
                            </label>

                            <label className="relative cursor-pointer">
                                <input
                                    type="radio"
                                    name="gateway"
                                    value="crypto"
                                    checked={selectedGateway === "crypto"}
                                    onChange={(e) => handleGatewayChange(e.target.value)}
                                    className="sr-only peer"
                                />
                                <div
                                    className="bg-gray-50 border-2 border-gray-200 rounded-2xl p-4 peer-checked:border-blue-600 peer-checked:bg-blue-50 transition-all">
                                    <div className="flex flex-col items-center text-center">
                                        <FaBitcoin className="text-2xl text-gray-600 peer-checked:text-blue-600 mb-2"/>
                                        <span className="text-sm font-medium text-gray-700">
                      Cryptocurrency
                    </span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                    {/* Amount Input */}
                    <div className="mb-6">
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                            Withdrawal Amount
                        </label>
                        <div className="relative">
              <span className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg">
                USDT
              </span>
                            <div
                                className="w-full pr-20 pl-16 py-4 bg-gray-50 border border-gray-200 rounded-2xl text-lg font-medium focus:outline-none focus:ring-2 focus:ring-blue-600/20 focus:border-blue-600 transition-all text-end flex items-center justify-end relative">
                                <input
                                    type="number"
                                    placeholder="0"
                                    value={withdrawAmount || ""}
                                    onChange={handleAmountChange}
                                    className="absolute inset-0 w-full h-full bg-transparent text-transparent caret-blue-600 text-end pr-20 pl-16 text-lg font-medium focus:outline-none"
                                    inputMode="numeric"
                                />
                                <span className="pointer-events-none text-gray-900">
                  {formatPrice(withdrawAmount)}
                </span>
                            </div>
                            <button
                                onClick={handleMaxAmount}
                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-600 font-medium text-sm hover:text-blue-700 transition-colors"
                            >
                                Max
                            </button>
                        </div>
                        <div className="flex justify-between mt-2 text-sm text-gray-500">
                            <span>Balance: {formatPrice(BALANCE)} USDT</span>
                            <span>Minimum: {formatPrice(MINIMUM_AMOUNT)} USDT</span>
                        </div>
                    </div>

                    {/* Quick Amount Buttons */}
                    <div className="mb-6">
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                            Quick Select
                        </label>
                        <div className="grid grid-cols-4 gap-2">
                            {QUICK_AMOUNTS.map((amount) => (
                                <button
                                    key={amount}
                                    onClick={() => handleQuickAmount(amount)}
                                    className={`py-3 rounded-xl text-sm font-medium transition-all ${
                                        withdrawAmount === amount
                                            ? "bg-blue-600 text-white border border-blue-600"
                                            : "bg-gray-50 border border-gray-200 text-gray-700 hover:bg-blue-50 hover:border-blue-600 hover:text-blue-600"
                                    }`}
                                >
                                    {formatPrice(amount)}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Transaction Summary */}
                <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">Transaction Summary</h3>
                    <div className="space-y-3">
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Withdrawal Amount</span>
                            <span className="font-semibold text-gray-900">
                {formatPrice(withdrawAmount)} USDT
              </span>
                        </div>
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Fee</span>
                            <span className="font-semibold text-gray-900">
                {formatPrice(FIXED_FEE)} USDT
              </span>
                        </div>
                        <div className="border-t border-gray-100 pt-3">
                            <div className="flex justify-between items-center">
                <span className="text-lg font-semibold text-gray-900">
                  Final Amount
                </span>
                                <span className="text-lg font-bold text-blue-600">
                  {(finalAmount)} USDT
                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recent Withdrawals */}
                <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-32">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">
                        Recent Withdraws
                    </h3>
                    <div className="space-y-4">
                        {withDraws.length > 0
                            ?
                            withDraws.map((withdraw, index) => (
                                <div
                                    key={withdraw._id}
                                    ref={index === withDraws.length - 1 ? lastWithdrawRef : null}
                                    className="w-full p-4 rounded-xl flex items-center justify-between border bg-gray-50"
                                >

                                    <div className={'flex flex-col gap-2'}>
                                        <p className={'font-bold text-lg'}>
                                            {withdraw.amount} {" "}
                                            <span className={'text-sm text-gray-400'}>
                                                USDT
                                            </span>
                                        </p>
                                        <p className={'text-gray-400 text-sm'}>
                                            {fixDate(withdraw.createdAt)}
                                        </p>
                                    </div>

                                    <div
                                        className={`p-2 rounded-lg border h-fit ${
                                            withdraw.status === "accepted"
                                                ? "border-green-600 text-green-600 bg-green-200"
                                                : withdraw.status === "pending"
                                                    ? "border-amber-500 text-amber-500 bg-amber-200"
                                                    : "border-red-600 text-red-600 bg-red-200"
                                        }`}
                                    >
                                        {`${withdraw.status[0].toUpperCase()}${withdraw.status.slice(1)}`}
                                    </div>
                                </div>
                            ))
                            :
                            <p className={'text-sm text-gray-900 w-full text-center'}>
                                No Withdraws found.
                            </p>
                        }
                        {loading && (
                            <div className="text-center py-4">
                                Loading more...
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="fixed bg-white border-t border-gray-200 p-5 bottom-0 z-[9999] w-full left-0 right-0">
                <button
                    onClick={SettleWithDraw}
                    disabled={withdrawAmount === 0 || btnLoading}
                    className="w-full bg-gradient-to-r from-blue-600 to-indigo-500 text-white py-4 rounded-2xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                >
                    {btnLoading ? "Please wait..." :
                        <>
                            <FaArrowDown/>
                            Withdraw Commission
                        </>
                    }

                </button>
            </div>
        </div>
    );
}